import './styles/customerly.css'

import React, { useEffect } from 'react'

import { useAppSelector } from '../../redux/hooks'
import CustomerlyImpl from './CustomerlyImpl'

const Customerly = (): JSX.Element | null => {
  const { openable } = useAppSelector((state) => state.chat.config)
  const adminMode = useAppSelector((state) => state.adminMode.value)
  const hideInternal = useAppSelector((state) => state.chat.hideInternal)
  const authInfo = useAppSelector((state) => state.auth)

  useEffect(() => {
    const className = 'hide-customerly-react-workaround'
    if (!adminMode && ((!authInfo.isAuth && !authInfo.isNotLogged) || (!hideInternal && openable)))
      document
        .querySelector<HTMLBodyElement>('body')
        ?.classList.remove(className)
    else
      document.querySelector<HTMLBodyElement>('body')?.classList.add(className)
  }, [openable, adminMode, hideInternal, authInfo.isAuth, authInfo.isNotLogged])

  return !adminMode && (!authInfo.isAuth || openable) ? <CustomerlyImpl /> : <></>
}

export default Customerly
